import { ConfirmationModal } from '../../shared';
import { Button } from '../../ui/button';
import { useDisclosure } from '../../../hooks/useDisclosure';
import { cn } from '../../ui/utils';
import { getUnsatisfiedChoiceGroups } from '../../../utils/choiceGroups';

const EndTest = (props) => {
  const {
    onEndTest,
    buttonText = 'End Test',
    isSubmittingResponse,
    className,
    highlighted = false,
    assignment,
    studentResponse
  } = props;
  const { isOpen, onOpen, onClose } = useDisclosure();

  // Leaving a choice group short of its required count silently costs marks the student
  // could still pick up, so it is worth saying before the paper is handed in. It stays a
  // warning: they are free to submit anyway.
  const shortGroups = getUnsatisfiedChoiceGroups(assignment, studentResponse);

  const modalText =
    shortGroups.length === 0 ? (
      'Are you sure you want to end this assignment?'
    ) : (
      <div className="space-y-2">
        <p>You have not answered enough questions in these sets:</p>
        <ul className="list-disc space-y-1 pl-5">
          {shortGroups.map(({ group, progress }) => (
            <li key={group.id}>
              <span className="font-medium">
                Attempt any {progress.requiredCount} of {progress.total}
              </span>{' '}
              — {progress.answered} answered, {progress.remaining} to go
            </li>
          ))}
        </ul>
        <p>Are you sure you want to end this assignment?</p>
      </div>
    );

  return (
    <>
      <Button
        type="button"
        variant="default"
        size="sm"
        onClick={onOpen}
        disabled={isSubmittingResponse}
        className={cn(
          'font-semibold',
          highlighted && 'bg-primary text-primary-foreground shadow-sm ring-2 ring-primary/20 hover:bg-primary/90',
          className
        )}
      >
        {buttonText}
      </Button>
      <ConfirmationModal
        isOpen={isOpen}
        onClose={onClose}
        primaryButtonText={buttonText}
        secondaryButtonText="Cancel"
        modalText={modalText}
        onAction={onEndTest}
      />
    </>
  );
};

export { EndTest };
